interface LanguageDetail {
  name: string;
  flagName: string;
}

export const SUPPORTED_LANGUAGES = { DE: 'de', EN: 'en' } as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[keyof typeof SUPPORTED_LANGUAGES];

const SUPPORTED_LANGUAGE_SET = new Set<string>(Object.values(SUPPORTED_LANGUAGES));

function isSupportedLanguage(value: string): value is Language {
  return SUPPORTED_LANGUAGE_SET.has(value);
}

// Map a BCP-47 tag (e.g. "de-DE", "es-419") to a supported language. The full
// tag is tried first so region-specific variants stay distinct when they are
// themselves supported (e.g. "es-ES" vs "es-419", or Flemish "nl-BE" vs "nl"),
// then progressively shorter tags are tried. Returns null when nothing matches.
export function normalizeLanguage(raw: string | undefined | null): Language | null {
  if (!raw) {
    return null;
  }
  const parts = raw.split('-');
  for (let end = parts.length; end > 0; end--) {
    const candidate = parts.slice(0, end).join('-');
    if (isSupportedLanguage(candidate)) {
      return candidate;
    }
  }
  return null;
}

export const LANGUAGES_DETAILS: Record<Language, LanguageDetail> = {
  [SUPPORTED_LANGUAGES.DE]: { name: 'Deutsch', flagName: 'de.svg' },
  [SUPPORTED_LANGUAGES.EN]: { name: 'English', flagName: 'en.svg' },
};
